import {Action, handleActions} from "redux-actions";
import {none, option} from "ts-option";
import {
	FINANCE_PRODUCT_CREATED,
	FINANCE_PRODUCT_UPDATED,
	FINANCE_PRODUCTS_FETCHED,
	FINANCE_PRODUCTS_SORT_ORDER_UPDATED
} from "../../action/financeProduct/actionType";
import {FinanceProductState} from "./FinanceProductState";

/**
 * Initial state for finance products.
 */
const initState: FinanceProductState = {
	financeProducts: none
};

const reducer = handleActions({
	[FINANCE_PRODUCTS_FETCHED]: (state: FinanceProductState, action: Action<any>): FinanceProductState => {
		return {...state, financeProducts: option(action.payload.products)};
	},
	[FINANCE_PRODUCTS_SORT_ORDER_UPDATED]: (state: FinanceProductState,
		action: Action<FINANCE_PRODUCTS_SORT_ORDER_UPDATED>): FinanceProductState => {
		return {...state, financeProducts: option(action.payload.products)};
	},
	[FINANCE_PRODUCT_CREATED]: (state: FinanceProductState, action: Action<FINANCE_PRODUCT_CREATED>): FinanceProductState => {
		return {...state, financeProducts: option(state.financeProducts.getOrElse([]).concat(action.payload.product))};
	},
	[FINANCE_PRODUCT_UPDATED]: (state: FinanceProductState, action: Action<FINANCE_PRODUCT_UPDATED>): FinanceProductState => {
		const financeProducts = state.financeProducts.getOrElse([]).map(product => {
			if (product.id == action.payload.product.id) {
				return action.payload.product;
			}
			else {
				return product;
			}
		});
		return {...state, financeProducts: option(financeProducts)};
	},
}, initState);

export default reducer;